<template>
  <div>
    <div v-if="show">
      <div class="agency-top">
        <img src="../../assets/images/bg_02.jpg" class="img" />
        <div class="agency-t-m">
          <div class="agency-t-m-1"><img :src="user.avatar" /></div>
          <div class="agency-t-m-2">
            <p class="u-name">{{ userInfo.username }}</p>
            <span class="u-phone" v-if="this.$store.state.phone != null">{{ user.phone }}</span>
          </div>
        </div>
        <div class="agency-t-r">
          <div class="agency-t-r-w">
            <router-link to="/users/setting">
              <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-tubiao112"></use>
                </svg>
              </span>
              <p>设置</p>
            </router-link>
          </div>
        </div>
      </div>
      <div class="user-a">
        <h3 class="h3"><img src="../../assets/images/ico_s_01.png" width="20" class="img" />总分</h3>
        <div class="u-b">
          <div class="u-b-li">
            <span class="price">0</span>
            <span class="info">总分</span>
          </div>
          <div class="u-b-li">
            <span class="price">0</span>
            <span class="info">余额</span>
          </div>
        </div>
        <div class="u-c">
          <ul>
            <li><router-link to="">结算明细</router-link></li>
            <li><router-link to="">提现管理</router-link></li>
          </ul>
        </div>
      </div>
    </div>

    <Footer />
    <Laod ref="laoding" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Icon, Badge } from 'vant'

  export default {
    components: {
      [Icon.name]: Icon,
      [Badge.name]: Badge,
    },
    name: 'index',
    data() {
      return {
        show: false,
        user: [],
        userInfo: this.$store.state
      }
    },
    created () {
      if(this.userInfo.name != null) {
        this.userInfo.username = this.userInfo.name
      }else if(this.userInfo.nickname != null) {
        this.userInfo.username = this.userInfo.nickname
      }
      this.getUser()
    },
    methods: {
      getUser() {
        this.$api.get('fw/auth/user', {id: localStorage.getItem('uid')}, r=>{
          this.user = r.result
          this.show = true
          this.$refs.laoding.loadClose()
        })
      },
      upgrade() {

      }
    }
  }
</script>

<style scoped>
  .u-orders{
    background: #ffffff;
    padding:15px 0;
    overflow: hidden;
  }
  .u-orders .h3{
    margin: 0;
    font-size: 16px;
    font-weight: normal;
    padding:0 15px 10px;
    border-bottom: 1px solid #eff1f3;
  }
  .u-orders .h3 .u-o-more{
    float: right;
    font-size: 15px;
  }
  .u-orders .h3 .u-o-more .ico{
    font-size: 20px;
    float: right;
  }
  .u-orders .u-o-m{

  }
  .u-orders .u-o-m ul li{
    float: left;
    width: 25%;
    text-align: center;
  }
  .u-orders .u-o-m ul li a{
    display: block;
    padding:15px 0 5px;
  }
  .u-orders .u-o-m ul li span{
    font-size: 30px;
  }
  .u-orders .u-o-m ul li p{
    margin: 0;
    font-size: 14px;
  }

  .user-a{
    margin-top: 10px;
    overflow: hidden;
    padding:10px 15px;
    background: #ffffff;
  }
  .user-a .h3{
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }
  .user-a .h3 .img{
    float: left;
    margin-right: 5px;
  }
  .user-a .u-b{
    overflow: hidden;
    padding:15px 0;
  }
  .user-a .u-b .u-b-li{
    width: 41%;
    float: left;
    border-right: 1px solid #DCDEE0;
    padding:0 4%;
  }
  .user-a .u-b .u-b-li:last-child{
    border-right: none;
  }
  .user-a .u-b .u-b-li span{
    display: block;
  }
  .user-a .u-b .u-b-li .price{

  }
  .user-a .u-b .u-b-li .info{
    color:#969799;
    font-size: 12px;
    margin-top: 3px;
  }
  .user-a .u-c{
    overflow: hidden;
  }
  .user-a .u-c ul li{
    float: left;
    background: #FFFBE8;
    border-radius: 3px;
    width: 46%;
    margin:2%;
  }
  .user-a .u-c ul li a{
    color:#ed6a0c;
    display: block;
    text-align: center;
    padding:3% 0;
    font-size: 14px;
  }
  .user-b{
    margin-top: 10px;
    padding:15px 0;
    overflow: hidden;
    background: #ffffff;
  }
  .user-b ul li{
    float: left;
    width: 25%;
    text-align: center;
  }
  .user-b ul li a img{
    width: 60%;
  }
  .user-b ul li a span{
    display: block;
    font-size: 14px;
  }
  .user-c{
    background: #ffffff;
    padding:15px;
    margin-top: 10px;
    overflow: hidden;
  }
  .user-c .h3{
    font-size: 16px;
    font-weight: normal;
    margin:0;
  }
  .user-c ul li{
    float: left;
    width: 20%;
    text-align: center;
    padding-top:10px;
  }
  .user-c ul li span{
    font-size: 30px;
  }
  .user-c ul li p{
    margin: 0;
    font-size: 14px;
  }
  .user-d{
    margin-top: 10px;
    background: #ffffff;
    padding:10px 15px;
    overflow: hidden;
  }
  .user-d .h3{
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }
  .user-d .h3 .img{
    float: left;
    margin-right: 5px;
  }
  .user-d .h3 .u-d-recharge{
    float: right;
    font-size: 15px;
  }
  .user-d .h3 .u-d-recharge .ico{
    font-size: 20px;
    float: right;
  }
  .user-d .u-d-price{
    font-size: 14px;
    padding:10px 15px;
  }
  .user-d .u-d-ul li{
    float: left;
    background: #FFFBE8;
    border-radius: 3px;
    width: 46%;
    margin:2%;
  }
  .user-d .u-d-ul li a{
    color:#ed6a0c;
    display: block;
    text-align: center;
    padding:3% 0;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/index.vue